<template>
    <div ref="optionalCard" class="card" style="display: inline-block">
        <div class="card-body green-left-border">
            <Header ref="header" :name="optionaleMerkmale.i18NName" :visible="isSelected"
                    v-on:reset-elements="resetCheckboxes"
                    :i18NPictureId="optionaleMerkmale.i18NPictureId"
                    :i18NDescription="optionaleMerkmale.i18NDescription" />
            <div class="custom-control custom-checkbox">
                <div v-for="(wert, index) in optionaleMerkmale.merkmale" v-bind:key="wert.name">
                    <input ref="radioButtons" type="checkbox" class="custom-control-input"
                           :id="$id('optionles-merkaml' + index)"
                           :name="optionaleMerkmale.name"
                           v-model="selected" :value="wert"
                           :disabled="wert.disabled">
                    <label class="custom-control-label" :for="$id('optionles-merkaml' + index)">
                        {{wert.i18NName}}
                        <Vorzugswert :vorzugswert="wert.vorzugswert"/>
                        <I18NImage :i18-n-pic-id="wert.i18NPictureId" :pic-title="wert.i18NName" :i18-n-description="wert.i18NDescription" />
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Header from "@/components/config-page/utils/Header";
    import Vorzugswert from "@/components/config-page/utils/Vorzugswert";
    import I18NImage from "@/components/config-page/utils/I18NImage";

    export default {
        name: 'OptionaleGruppe',
        components: {Header, Vorzugswert, I18NImage},
        props: ['optionaleMerkmale'],
        data: function() {
            return {
                isTheChangedOne: false
            }
        },
        computed: {
            isSelected: function () {
                return this.optionaleMerkmale.selected.length > 0;
            },
            selected: {
                get() {
                    return this.optionaleMerkmale.selected;
                },
                set(value) {
                    this.commitSetSelectedOptionalesMerkmal(value);
                }
            }
        },
        watch: {
            optionaleMerkmale: {
                handler: function(optionaleMerkmale, oldOptionaleMerkmale) {
                    if (!this.isTheChangedOne && JSON.stringify(optionaleMerkmale) !== JSON.stringify(oldOptionaleMerkmale)) {
                        this.$refs.optionalCard.classList.add('mark-change');
                        setTimeout(() => {
                            this.$refs.optionalCard.classList.remove('mark-change');
                        }, 2000);
                    }
                    this.isTheChangedOne = false;
                },
                deep: true
            }
        },
        methods: {
            resetCheckboxes() {
                this.commitSetSelectedOptionalesMerkmal([]);
            },
            commitSetSelectedOptionalesMerkmal(value) {
                this.isTheChangedOne = true;
                let optionaleMerkmale = this.optionaleMerkmale;
                this.$store.commit('setSelectedOptionalesMerkmal', {optionaleMerkmale:optionaleMerkmale, value:value});
            }
        },
    }
</script>

<style scoped>

</style>